module.exports = "/images/quotazioni-ruoteclassiche-logo.png?c0d6353c9416e509accd919ff70f1cd9";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/quotazioni-ruoteclassiche-logo.png
// module id = L5dx
// module chunks = 1